import React, { useEffect } from "react";
import {
  checkIfUserIsLoggedIn,
  checkIfUserHasValidPortalToken,
} from "shared/utility/AuthUtility";
import { getAuthInfoFromStorage } from "shared/utility/TokenStorageUtility";
import { getCurrentUserDetail } from "store/slices/UserSlice";
import { setAuthInfo } from "store/slices/AuthenticationSlice";
import { AppDispatch, RootState } from "store/store";
import { connect } from "react-redux";
import Header from "components/header";
import { getConfiguration } from "shared/utility/ConfigUtility";
import { setSelectedProductId } from "store/slices/ProductSlice";
import { setSelectedProductSubscriptionId } from "store/slices/SubscriptionSlice";
import ProductSubscription from "interfaces/response/ProductSubscription";
import Loader from "components/common/controls/Loader";
import { getSelectedProductId } from "shared/utility/ProductSubscriptionHelper";
import RefreshTokenConfirmation from "fetaures/authentication/RefreshTokenConfirmation";

interface Props {
  children: React.ReactNode;
  isAuthenticated: boolean;
  selectedProductId?: number | null;
  dispatch: AppDispatch;
  isUserDataLoaded: boolean;
  productSubscriptions: ProductSubscription[];
  isUserDataLoading: boolean;
  tokenExpirationTime: string;
}

export function AuthProtectedPageLayout(props: Props) {
  const timePhasingProductId = 1;
  const {
    children,
    isAuthenticated,
    isUserDataLoaded,
    selectedProductId,
    productSubscriptions,
    isUserDataLoading,
    tokenExpirationTime,
    dispatch,
  } = props;

  useEffect(() => {
    dispatch(getCurrentUserDetail());
  }, [dispatch]);

  useEffect(() => {
    // If isAuthenticated from store is false and local storage have valid token, that means page
    // has been reloaded(store has been refreshed). In that case, set auth information from local storage
    // to redux store.
    if (!isAuthenticated && checkIfUserHasValidPortalToken()) {
      const authInfoFromStorage = getAuthInfoFromStorage();
      if (authInfoFromStorage) {
        dispatch(setAuthInfo(authInfoFromStorage));
      }
    }
  }, [isAuthenticated, dispatch]);

  useEffect(() => {
    // In future we will set selectedProductId from ui where we will be able to choose product.
    const setSelectedProductIdAndSubscriptionId = () => {
      const defaultProductId = getConfiguration("defaultProductId");
      const subscriptionId = (productSubscriptions || []).find(
        (ps) => ps.id === defaultProductId
      )?.subscriptionId;
      dispatch(setSelectedProductId(defaultProductId));
      dispatch(setSelectedProductSubscriptionId(subscriptionId));
    };

    if (isUserDataLoaded) {
      setSelectedProductIdAndSubscriptionId();
    }
  }, [isUserDataLoaded, productSubscriptions, dispatch]);

  return (
    <div className="xl:px-28 bg-promWhite1 min-h-screen px-4 overflow-hidden">
      <div className="mt-11">
        {isAuthenticated && (
          <>
            <div className="mb-4 xl:mb-12">
              <Header />
            </div>
            {selectedProductId === timePhasingProductId && <>{children}</>}
            <RefreshTokenConfirmation
              tokenExpirationTime={tokenExpirationTime}
            />
          </>
        )}
        <Loader isVisible={isUserDataLoading} />
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState, props: any) => {
  return {
    isUserLoggedIn: checkIfUserIsLoggedIn(),
    isAuthenticated: state.authData.isAuthenticated,
    productSubscriptions: state.userData.currentUserDetail?.products,
    selectedProductId: getSelectedProductId(state),
    isUserDataLoaded: state.userData.currentUserDetail?.id !== 0,
    isUserDataLoading: state.userData.loading,
    tokenExpirationTime: state.authData.expires,
    ...props,
  };
};

export default connect(mapStateToProps)(AuthProtectedPageLayout);
